import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons/faArrowLeft'
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle'
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons/faExclamationTriangle'
import { faTimes } from '@fortawesome/pro-solid-svg-icons/faTimes'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { useHistory } from 'react-router-dom'
import { PathRoutes } from 'enum/routes'
import { useRolesAndPermissions } from '../../../context/RolesAndPermissionsContext'
import { Wrapper, Alert, WarningAlert } from './styled'

const Header = () => {
  const { t } = useTranslation()
  const prefix = 'configuration.rolesAndPermissions.form.header'
  const history = useHistory()
  const { id: roleId } = useParams<{ id: string }>()
  const isEditing = Boolean(roleId)
  const { roleDetail: data } = useRolesAndPermissions()
  const isDefaultRole = isEditing && data.isDefault
  const [isOpen, setIsOpen] = useState(true)
  const showAlert = isOpen && (!isEditing || isDefaultRole)

  const goBack = () => {
    history.push(PathRoutes.ROLES_AND_PERMISSIONS)
  }

  const AlertComponent = isDefaultRole ? WarningAlert : Alert
  const alertMessage = isDefaultRole
    ? t(`${prefix}.alert.warning`)
    : t(`${prefix}.alert.info`)
  const alertIcon = isDefaultRole ? faExclamationTriangle : faInfoCircle

  return (
    <Wrapper>
      <FontAwesomeIcon onClick={goBack} icon={faArrowLeft as IconProp} />
      <span>
        {isEditing
          ? t(`${prefix}.title.editRole`)
          : t(`${prefix}.title.newRole`)}
      </span>
      {showAlert && (
        <AlertComponent>
          <FontAwesomeIcon icon={alertIcon as IconProp} />
          {alertMessage}
          <FontAwesomeIcon
            icon={faTimes as IconProp}
            onClick={() => setIsOpen(false)}
          />
        </AlertComponent>
      )}
    </Wrapper>
  )
}

export default Header
